import React from "react";

const SuccessIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.189"
      height="19.189"
      viewBox="0 0 19.189 19.189"
    >
      <path
        id="corref"
        d="M48,40a8,8,0,1,0,8,8A8,8,0,0,0,48,40Zm4.4,6.533-5.333,4a.667.667,0,0,1-.934-.133l-2-2.667a.667.667,0,0,1,1.067-.8l1.6,2.133,4.8-3.6a.667.667,0,0,1,.8,1.067Z"
        transform="translate(-47.973 -26.378) rotate(-13)"
        fill={fill ? fill : "#14c037"}
      />
    </svg>
  );
};

export default SuccessIcon;
